import React, { useEffect, useRef } from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {

  // Google Calendar appointment button
  const calendarRef = useRef(null);

  useEffect(() => {
    const CAL_CSS = 'https://calendar.google.com/calendar/scheduling-button-script.css';
    const CAL_JS = 'https://calendar.google.com/calendar/scheduling-button-script.js';

    // inject CSS once
    if (!document.querySelector(`link[href="${CAL_CSS}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = CAL_CSS;
      document.head.appendChild(link);
    }

    function loadButton() {
      if (window.calendar && window.calendar.schedulingButton && calendarRef.current) {
        try {
          // derive primary color from CSS variables, fallback to theme blue
          const rootStyles = getComputedStyle(document.documentElement);
          const cssVar = rootStyles.getPropertyValue('--primary-color')?.trim();
          const themeColor = cssVar && cssVar.startsWith('#') ? cssVar : '#2563eb';
          window.calendar.schedulingButton.load({
            url: 'https://calendar.google.com/calendar/appointments/schedules/AcZssZ1nuABdk88R2AfQTb3n6gxwsUh-Tai_LGuJrA7dGX2bm3s_B6OCLqMBg-U5w1EJy82enNSAP-Oa?gv=true',
            color: themeColor,
            label: 'Book - 30 mins',
            target: calendarRef.current,
          });
        } catch (e) {
          // noop
        }
      }
    }

    // inject script once
    if (!document.querySelector(`script[src="${CAL_JS}"]`)) {
      const script = document.createElement('script');
      script.src = CAL_JS;
      script.async = true;
      script.onload = loadButton;
      document.body.appendChild(script);
    } else {
      // script already present
      loadButton();
    }
  }, []);

  // Optional embedded form providers (set one of these to enable an inline form)
  const typeformUrl = '';
  const googleFormUrl = 'https://forms.gle/1uNns8Mm3MJBNyx97';

  const renderEmbeddedForm = () => {
    if (typeformUrl) {
      return (
        <div className="embed-container">
          <iframe
            title="Typeform"
            src={typeformUrl}
            frameBorder="0"
            allow="camera; microphone; autoplay; encrypted-media;"
            allowFullScreen
          />
        </div>
      );
    }
    if (googleFormUrl) {
      return (
        <div className="embed-container">
          <iframe
            title="Google Form"
            src={googleFormUrl}
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          />
        </div>
      );
    }
    return null;
  };

  // removed legacy form handlers

  return (
    <section id="contact" className="contact">
      <div className="container">
        <h2 className="section-title">Get in Touch</h2>
        <p className="section-subtitle">
          Let's collaborate on your next AI project or discuss speaking opportunities
        </p>

        <div className={`contact-content ${(!typeformUrl && !googleFormUrl) ? 'single-column' : ''}`}>
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>
              I'm always interested in hearing about new opportunities, collaborations, 
              and innovative projects in the AI space. Whether you need help with GenAI 
              implementation, want me to speak at your event, or just want to chat about 
              vector databases and RAG, feel free to reach out!
            </p>

            <div className="contact-methods">
              <a 
                href="mailto:deepti.naidu@gmail.com"
                className="contact-method"
              >
                <div className="method-icon">
                  <FaEnvelope />
                </div>
                <div className="method-info">
                  <h4>Email</h4>
                  <p>deepti.naidu@gmail.com</p>
                </div>
              </a>

              <a 
                href="https://www.linkedin.com/in/deeptinaidu/"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-method"
              >
                <div className="method-icon">
                  <FaLinkedin />
                </div>
                <div className="method-info">
                  <h4>LinkedIn</h4>
                  <p>Connect with me</p>
                </div>
              </a>

              <a 
                href="https://github.com/dee-at-weaviate"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-method"
              >
                <div className="method-icon">
                  <FaGithub />
                </div>
                <div className="method-info">
                  <h4>GitHub</h4>
                  <p>Check out my code</p>
                </div>
              </a>
            </div>

            <div className="calendar-container">
              <h4>Book a Meeting With Me</h4>
              <div ref={calendarRef} />
            </div>
          </div>

          {renderEmbeddedForm()}
        </div>
      </div>
    </section>
  );
};

export default Contact;

